<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{ $t('Download-Integration-File') }} </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-flex>

          <v-container fluid="">
            <v-card color="grey lighten-5" flat>
              <v-layout row wrap>
                <v-flex xs12 sm4 md2>
                  <v-menu
                    :close-on-content-click="true"
                    v-model="menu"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      :label="$t('Starting-Date')"
                      v-model="dateFormatted"
                      append-icon="event"
                      v-on:change="onChange"
                      mask="##.##.####"
                      @blur="date = parseDate(dateFormatted)"
                      data-vv-name="tarihsec"
                      :error-messages="errors.collect('tarihsec')"
                      v-validate="'required'"
                      required
                    ></v-text-field>
                    <v-date-picker
                      locale="tr"
                      v-model="date"
                      @input="dateFormatted = formatDate($event)"
                      no-title
                      scrollable
                      actions
                    >
                      <v-spacer></v-spacer>
                    </v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 sm4 md2>
                  <v-menu
                    :close-on-content-click="true"
                    v-model="menu2"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      :label="$t('Finishing-Date')"
                      v-model="dateFormatted2"
                      append-icon="event"
                      v-on:change="onChange2"
                      mask="##.##.####"
                      @blur="date2 = parseDate2(dateFormatted2)"
                      data-vv-name="tarihsec1"
                      :error-messages="errors.collect('tarihsec1')"
                      v-validate="'required'"
                      required
                    ></v-text-field>
                    <v-date-picker
                      locale="tr"
                      v-model="date2"
                      @input="dateFormatted2 = formatDate2($event)"
                      no-title
                      scrollable
                      actions
                    >
                      <v-spacer></v-spacer>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm4 md2>
                  <v-layout align-center justify-center row fill-height>
                    <v-select
                      :items="tipitems"
                      :label="$t('Process-Type')"
                      v-model="tip"
                    ></v-select>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm1 md1>
                  <v-layout>
                    <div v-if="load1">
                      <v-btn color="info" @click="getList()" fab small="" dark>
                        <v-icon>save_alt</v-icon>
                      </v-btn>
                    </div>
                                        <v-btn
                      color="info"
                      @click.native="dialog = true"
                      fab
                      small=""
                      dark
                    >
                      <v-icon>filter_list</v-icon>
                    </v-btn>
                    <div v-if="load">
                      <v-progress-circular
                        indeterminate
                        :width="4"
                        color="blue"
                      ></v-progress-circular>
                    </div>
                  </v-layout>
                </v-flex>
       
              </v-layout>
            </v-card>

            <v-layout row justify-center>
              <v-dialog v-model="dialog" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline">{{ $t('Filter-selection') }}</v-card-title>
                  <v-card-text
                    ><v-checkbox
                      :label="$t('Add-Temporary-Current-Tickets')"
                      v-model="geciciStatus"
                    ></v-checkbox
                  ></v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click.native="dialog = false"
                      >{{ $t('Cancel') }}</v-btn
                    >
                    <v-btn color="primary" flat @click="filtrele()"
                      >{{ $t('save_button') }}</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-layout>

            <v-layout row="" wrap>
              <v-flex xs12 sm12 md12>
                <span v-if="!load1">
                  {{ $t('Your-file-is-being-downloaded-Please-wait') }}</span
                >

                <v-snackbar
                  :timeout="timeout"
                  :top="y === 'top'"
                  :bottom="y === 'bottom'"
                  :right="x === 'right'"
                  :left="x === 'left'"
                  :multi-line="mode === 'multi-line'"
                  :vertical="mode === 'vertical'"
                  v-model="snackbar"
                >
                  {{ text1 }}
                  <v-btn flat color="pink" @click.native="snackbar = false">{{
                    $t("Close")
                  }}</v-btn>
                </v-snackbar>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import auth from "../../../api/auth";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "@/components/app/coper/tools.js";
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";

export default {
  data() {
    return {
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      tip: "0",
      search: "",

      tipitems: [
        {
          text: this.$t('Ticket'),
          value: "0",
        },
        {
          text: this.$t("Bill"),
          value: "1",
        },
        {
          text: this.$t("Refund"),
          value: "2",
        },
        {
          text: "Cari Hareket",
          value: "3",
        },
        {
          text: this.$t('Free-Invoice'),
          value: "4",
        },
        {
          text: "Coper Fatura(Test)",
          value: "5",
        },
      ],

      headers: [
        {
          text: this.$t("Currentcode_label"),
          value: "Current",
        },
        {
          text: this.$t("Title_label"),
          value: "CurrentTitle",
        },
        {
          text: this.$t("Date"),
          value: "Date",
        },
        {
          text: this.$t("Document-Type"),
          value: "DocumentType",
        },
        {
          text: this.$t("Document-No"),
          value: "DocumentNumber",
        },
        {
          text: this.$t("Description"),
          value: "Explanation",
        },
        {
          text: this.$t("Maturity-Date"),
          value: "DueDate",
        },
        {
          text: this.$t('Debit'),
          value: "Debt",
        },
        {
          text: this.$t("Credit"),
          value: "Credit",
        },
        {
          text: this.$t("Balance"),
          value: "Balance",
        },
        {
          text: "B/A",
          value: "BAType",
        },
      ],

      StartDate: null,
      EndDate: null,
      statecari: [],
      searchcari: "",
      progress: false,

      renk1: "info",
      dialogfiltre: false,

      dictionary: {
        custom: {
          masrafkodu: {
            required: () => this.$t('Please-select'),
          },
          tarihsec: {
            required: () => this.$t('Please-select-a-date'),
          },
          tarihsec1: {
            required: () => this.$t('Please-select-a-date'),
          },
        },
      },

      date: null,
      menu: false,
      modal: false,
      dateFormatted: "",
      date2: null,
      menu2: false,
      dateFormatted2: "",
      modal2: false,
      loading: false,
      items: [],
      load: false,
      load1: true,
      search3: "",
      butondurum: true,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      tooltip: false,
      el: null,
      geciciStatus: false,
      dialog: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  beforeMount: beforeMount,
  components: {
    yetkidialog,
    hatadialog,
  },
  mounted() {
    this.$validator.localize("en", this.dictionary);
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    if (this.sayfayetki.Status == true) {
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          }
        });
    }
  },
  watch: {},
  methods: {
    formatDate(date) {
      var str = date;
      var n = str.search(".");
      if (n == 1) {
        return null;
      } else {
        const [year, month, day] = date.split("-");
        return `${day}.${month}.${year}`;
      }
    },
    formatDate2(date) {
      var str = date;
      var n = str.search(".");
      if (n == 1) {
        return null;
      } else {
        const [year, month, day] = date.split("-");
        return `${day}.${month}.${year}`;
      }
    },
    parseDate(date) {
      if (!date) return null;
      var str = date;
      var n = str.search("-");
      var m = str.length;
      if (n == 1) {
        const [month, day, year] = date.split("-");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      } else if (m == 8) {
      } else if (n == -1 && m != 8) {
        this.dateFormatted = getDateNow1();
        this.date = getDateNow();
      } else {
        const [day, month, year] = date.split(".");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
    },
    parseDate2(date) {
      if (!date) return null;
      var str = date;
      var n = str.search("-");
      var m = str.length;
      if (n == 1) {
        const [month, day, year] = date.split("-");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      } else if (m == 8) {
      } else if (n == -1 && m != 8) {
        this.dateFormatted2 = getDateNow1();
        this.date2 = getDateNow();
      } else {
        const [day, month, year] = date.split(".");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
    },
    getList: getList,
    getListHtml: getListHtml,
    getListExcel: getListExcel,
    CoperFatura: CoperFatura,
    HataYonetimi: HataYonetimi,

    onChange: onChange,
    onChange2: onChange2,
    filtrele: filtrele,
  },
};

function filtrele() {
  this.dialog = false;
  this.getList();
}

function HataYonetimi(response, request, baslik) {
  this.load1 = true;
  this.progress = false;
  if (response.status === 500) {
    this.$refs.hatadialog.open(response, request, baslik);
  } else {
    this.text = "Service Unavailable -" + baslik;
    this.snackbar = true;
  }
}

function CoperFatura() {
  let params = {
    FatTip: 0, //None = 0, Satis = 1, Komisyon = 2, Iade = 3, Gelen = 4, SatisIadesi = 5
    CariKod: null,
    MuhEnt: null,
    SeriNo: null,
    FaturaNo: null,
    Tarih1: this.date,
    Tarih2: this.date2,
    PNR_No: null,
    IslemRef: null,
    SaticiTip: null,
    SaticiKod: null,
    GenelFatId: null,
  };

  tool.api_post_FileDownload(this, "Coper/SatisFaturaEnt", params).then(
    (response) => {
      tool.CreateDownloadLink(response, "CoperFatura.xml");
      this.load1 = true;
    },
    (response) => {
      this.HataYonetimi(response, params, "CoperFatura Getirilemedi");
    }
  );
}

function getList() {
  this.$validator.validateAll().then((result) => {
    if (result) {
      var bastarih = new Date(this.date);
      var bittarih = new Date(this.date2);

      if (bastarih <= bittarih) {
      const diffTime = Math.abs(bittarih - bastarih);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
      
      if(diffDays > 30){
        this.text1 = this.$t('You-can-receive-your-Integration-File-once-30-days-maximum')
        this.snackbar = true;
        return false;
      }
        var credentials = JSON.parse(
          window.localStorage.getItem("credentials")
        );

        this.load1 = false;

        var params = {
          SirketKodu: credentials.SirketKodu,
          BaslangicTarih: this.date,
          BitisTarih: this.date2,
          GeciciStatus: this.geciciStatus,
        };

        if (this.tip == "0") {
          this.$http
            .post(
              auth.API_URL + "api/TicketIntegration/DownloadTicketIntegration",
              params,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {
                var blob = new Blob([response.data], {
                  type: "application/xml",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "bilet_entegrasyon.xml";
                link.click();
                this.load1 = true;
              },
              (response) => {
                if (response.status === 0) {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.load1 = true;
                  this.progress = false;
                } else {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.load1 = true;
                  this.progress = false;
                }
              }
            );
        } else if (this.tip == "1") {
          // var xhr = new XMLHttpRequest();

          // xhr.onreadystatechange = function () {
          //     if (xhr.readyState == 4) {
          //         alert("ready state = 4");
          //     }
          // };

          // xhr.open("POST", auth.API_URL + 'api/TicketIntegration/DownloadInvoiceIntegration', true);
          // xhr.setRequestHeader('Authorization','Bearer ' + auth.getAuthHeader() );
          // xhr.setRequestHeader("Content-type", "application/json; charset=utf-8");
          // xhr.timeout = 900000; // Set timeout to 4 seconds (4000 milliseconds)
          // xhr.ontimeout = function () { alert("Timed out!!!"); }
          // xhr.send(JSON.stringify(params));

          this.$http
            .post(
              auth.API_URL + "api/TicketIntegration/DownloadInvoiceIntegration",
              params,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {
                var blob = new Blob([response.data], {
                  type: "application/xml",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "fatura_entegrasyon.xml";
                link.click();
                this.load1 = true;
              },
              (response) => {
                if (response.status === 0) {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.load1 = true;
                  this.progress = false;
                } else {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.load1 = true;
                  this.progress = false;
                }
              }
            );
        } else if (this.tip == "2") {
          var params1 = {
            SirketKodu: credentials.SirketKodu,
            BaslangicTarihi: this.date,
            BitisTarihi: this.date2,
          };

          this.$http
            .post(
              auth.API_URL + "api/TicketIntegration/DownloadRefundIntegration",
              params1,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {
                var blob = new Blob([response.data], {
                  type: "application/xml",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "iade_entegrasyon.xml";
                link.click();
                this.load1 = true;
              },
              (response) => {
                if (response.status === 0) {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.load1 = true;
                  this.progress = false;
                } else {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.load1 = true;
                  this.progress = false;
                }
              }
            );
        } else if (this.tip == "3") {
          var params2 = {
            SirketKodu: credentials.SirketKodu,
            BaslangicTarihi: this.date,
            BitisTarihi: this.date2,
            Entegre: true,
            ListTipi: 3,
          };

          this.$http
            .post(
              auth.API_URL +
                "api/TicketIntegration/DownloadCurrentMovementIntegration",
              params2,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {
                var blob = new Blob([response.data], {
                  type: "application/xml",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "cari_entegrasyon.xml";
                link.click();
                this.load1 = true;
              },
              (response) => {
                if (response.status === 0) {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.load1 = true;
                  this.progress = false;
                } else {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.load1 = true;
                  this.progress = false;
                }
              }
            );
        } else if (this.tip == "4") {
          var params3 = {
            SirketKodu: credentials.SirketKodu,
            BaslangicTarih: this.date,
            BitisTarih: this.date2,
          };

          this.$http
            .post(
              auth.API_URL +
                "api/TicketIntegration/DownloadFreeInvoiceIntegration",
              params3,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {
                var blob = new Blob([response.data], {
                  type: "application/xml",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "serbestfatura_entegrasyon.xml";
                link.click();
                this.load1 = true;
              },
              (response) => {
                if (response.status === 0) {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.load1 = true;
                  this.progress = false;
                } else {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.load1 = true;
                  this.progress = false;
                }
              }
            );
        } else if (this.tip == "5") {
          this.CoperFatura();
        }
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true;
      }
    }
  });
}

function getListHtml() {
  var credentials = JSON.parse(window.localStorage.getItem("credentials"));
  this.progress = true;
  this.currentDebtTotal = 0;
  this.currentCreditTotal = 0;
  this.debtTotal = 0;
  this.creditTotal = 0;
  this.load1 = false;

  if (this.date == null) {
    this.date = getDateNow();
  }

  if (this.date2 == null) {
    this.date2 = getDateNow();
  }

  if (this.secilenevraklar.length > 0) {
    this.secilenevraklar.forEach((element) => {
      var evrak = {
        EvrakKod: element,
      };
      this.Ekstreinput.Evraklar.push(evrak);
    });
  }

  this.Ekstreinput.BaslangicTarih = this.date;
  this.Ekstreinput.BitisTarih = this.date2;

  if (this.tumsirketler === true) {
    this.Ekstreinput.SirketKodu = 0;
  } else {
    this.Ekstreinput.SirketKodu = credentials.SirketKodu;
  }

  var params = this.Ekstreinput;

  this.$http
    .post(auth.API_URL + "api/Abstract/ListWithoutCurrentHtml", params, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
      },
    })
    .then(
      (response) => {
        this.load = false;
        this.load1 = true;
        this.progress = false;
        var blob = new Blob([response.data], {
          type: "application/html",
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "TarihEkstre.html";
        link.click();
      },
      (response) => {
        if (response.status === 0) {
          this.text = "Service Unavailable";
          this.snackbar = true;
          this.load1 = true;
          this.progress = false;
        } else {
          this.text = "Service Unavailable";
          this.snackbar = true;
          this.load1 = true;
          this.progress = false;
        }
      }
    );
}

function getListExcel() {
  var credentials = JSON.parse(window.localStorage.getItem("credentials"));
  this.progress = true;
  this.currentDebtTotal = 0;
  this.currentCreditTotal = 0;
  this.debtTotal = 0;
  this.creditTotal = 0;
  this.load1 = false;

  if (this.date == null) {
    this.date = getDateNow();
  }

  if (this.date2 == null) {
    this.date2 = getDateNow();
  }

  if (this.secilenevraklar.length > 0) {
    this.secilenevraklar.forEach((element) => {
      var evrak = {
        EvrakKod: element,
      };
      this.Ekstreinput.Evraklar.push(evrak);
    });
  }

  this.Ekstreinput.BaslangicTarih = this.date;
  this.Ekstreinput.BitisTarih = this.date2;

  if (this.tumsirketler === true) {
    this.Ekstreinput.SirketKodu = 0;
  } else {
    this.Ekstreinput.SirketKodu = credentials.SirketKodu;
  }

  var params = this.Ekstreinput;

  this.$http
    .post(auth.API_URL + "api/Abstract/ListWithoutCurrentExcel", params, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
      },
      responseType: "arraybuffer",
    })
    .then(
      (response) => {
        this.load = false;
        this.load1 = true;
        this.progress = false;
        var blob = new Blob([response.data], {
          type: "application/xlsx",
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "TarihEkstre.xlsx";
        link.click();
      },
      (response) => {
        if (response.status === 0) {
          this.text = "Service Unavailable";
          this.snackbar = true;
          this.load1 = true;
          this.progress = false;
        } else {
          this.text = "Service Unavailable";
          this.snackbar = true;
          this.load1 = true;
          this.progress = false;
        }
      }
    );
}

function beforeMount() {
  this.dateFormatted = getDateNow1();
  this.date = getDateNow();
  this.dateFormatted2 = getDateNow1();
  this.date2 = getDateNow();
}

function onChange(v) {
  var c = v.length;
  var a = v;
  if (c == 8) {
    var b = a[4] + a[5] + a[6] + a[7] + "-" + a[2] + a[3] + "-" + a[0] + a[1];
    var ay = a[2] + a[3];
    var gun = a[0] + a[1];
    var yil = a[4] + a[5] + a[6] + a[7];

    a = new Date(b);

    if (a instanceof Date && !isNaN(a.valueOf())) {
      //şubatın 29 çekmesin
      if (ay == "02" && yil % 10 != 0 && gun == "29") {
        b = yil + "-" + ay + "-" + "28";
        this.date = b;
        this.dateFormatted = "28" + "-" + ay + "-" + yil;
        //31 nisan
      } else if (ay == "04" && gun == "31") {
        b = yil + "-" + ay + "-" + "30";
        this.date = b;
        this.dateFormatted = "30" + "-" + ay + "-" + yil;
        //31 haziran
      } else if (ay == "06" && gun == "31") {
        b = yil + "-" + ay + "-" + "30";
        this.date = b;
        this.dateFormatted = "30" + "-" + ay + "-" + yil;
        //31 eylül
      } else if (ay == "09" && gun == "31") {
        b = yil + "-" + ay + "-" + "30";
        this.date = b;
        this.dateFormatted = "30" + "-" + ay + "-" + yil;
        //31 kasım
      } else if (ay == "11" && gun == "31") {
        b = yil + "-" + ay + "-" + "30";
        this.date = b;
        this.dateFormatted = "30" + "-" + ay + "-" + yil;
      } else {
        this.date = b;
      }
    } else {
      this.dateFormatted = null;
    }
  } else {
    this.dateFormatted = null;
  }
}

function onChange2(v) {
  var c = v.length;
  var a = v;
  if (c == 8) {
    var b = a[4] + a[5] + a[6] + a[7] + "-" + a[2] + a[3] + "-" + a[0] + a[1];
    var ay = a[2] + a[3];
    var gun = a[0] + a[1];
    var yil = a[4] + a[5] + a[6] + a[7];

    a = new Date(b);
    if (a instanceof Date && !isNaN(a.valueOf())) {
      //şubatın 29 çekmesi
      if (ay == "02" && yil % 10 != 0 && gun == "29") {
        b = yil + "-" + ay + "-" + "28";
        this.date2 = b;
        this.dateFormatted2 = "28" + "-" + ay + "-" + yil;
        //31 nisan
      } else if (ay == "04" && gun == "31") {
        b = yil + "-" + ay + "-" + "30";
        this.date2 = b;
        this.dateFormatted2 = "30" + "-" + ay + "-" + yil;
        //31 haziran
      } else if (ay == "06" && gun == "31") {
        b = yil + "-" + ay + "-" + "30";
        this.date2 = b;
        this.dateFormatted2 = "30" + "-" + ay + "-" + yil;
        //31 eylül
      } else if (ay == "09" && gun == "31") {
        b = yil + "-" + ay + "-" + "30";
        this.date2 = b;
        this.dateFormatted2 = "30" + "-" + ay + "-" + yil;
        //31 kasım
      } else if (ay == "11" && gun == "31") {
        b = yil + "-" + ay + "-" + "30";
        this.date2 = b;
        this.dateFormatted2 = "30" + "-" + ay + "-" + yil;
      } else {
        this.date2 = b;
      }
    } else {
      this.dateFormatted2 = null;
    }
  } else {
    this.dateFormatted2 = null;
  }
}

function getDateNow() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }
  today = yyyy + "-" + mm + "-" + dd;
  return today;
}

function getDateNow1() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }
  today = dd + "." + mm + "." + yyyy;
  return today;
}
</script>

<style>
</style>
